'use strict';
import { renderFragment, queryFirst, queryAll, addClass, removeClass } from 'lilly/domUtil';

const { initCarouselElement } = require('../components/swiperCarousel').default;
const { hasVideos, initVideos } = require('../components/video').default;
const shoppableMediaContainer = queryFirst('.js-shoppable-media-container');

/**
 * Fetches Shoppable Media data for a given URL.
 * @param {string} shoppablemediaUrl - The URL to fetch Shoppable Media data from.
 * @param {string} productId - The product ID associated with the Shoppable Media data.
 */
function updateShoppableMediaModule(shoppablemediaUrl, productId) {
    if (!shoppableMediaContainer) return;
    // Clear any existing content for shoppable media
    shoppableMediaContainer.innerHTML = '';
    const { hasShoppableMedia } = shoppableMediaContainer.dataset;
    if (!shoppablemediaUrl || !productId || !hasShoppableMedia) {
        return;
    }
    const $spinner = $(shoppableMediaContainer).spinner();

    $spinner.start();

    fetch(shoppablemediaUrl, { method: 'GET' })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.text();
        })
        .then(data => {
            // Clear any existing content
            shoppableMediaContainer.innerHTML = '';
            // Not JSON, treat as HTML
            if (data) {
                try {
                    const json = JSON.parse(data);
                    if (json && json.error) {
                        return;
                    }
                } catch (error) {
                    // Not JSON, treat as HTML
                }
                shoppableMediaContainer.appendChild(renderFragment(data));
                // init swiper carousel
                const shoppableCarouselEl = queryFirst('.js-shoppable-media', shoppableMediaContainer);
                const videoComponent = queryFirst('.video-component', shoppableMediaContainer);

                if (shoppableCarouselEl) {
                    const slides = queryAll('.swiper-slide', shoppableCarouselEl);

                    slides.forEach(slide => {
                        if (!slide.innerHTML.trim()) {
                            slide.remove();
                        }
                    });

                    const remainingSlides =  queryAll('.swiper-slide', shoppableCarouselEl);

                    if (remainingSlides.length === 1) {
                        const slide = remainingSlides[0];
                        removeClass(slide, 'smtile-small');
                        addClass(slide, 'smtile-medium');
                    }

                    initCarouselElement(shoppableCarouselEl);
                }

                if (hasVideos(videoComponent)) {
                    initVideos(videoComponent);
                }
            }
            $spinner.stop();
            shoppableMediaContainer.dataset.shoppablemediaProductId = productId;
            shoppableMediaContainer.dataset.shoppablemediaUrl = shoppablemediaUrl;
            shoppableMediaContainer.dataset.gaImpressions = 'false'; // reset GA impressions flag
            // Verify if the shoppable media container has content (base elements) before triggering the event
            const shoppableMediaTitleBlock = queryFirst('.shoppable-media-title-block', shoppableMediaContainer);
            if (shoppableMediaTitleBlock) {
                // Trigger event to initialize GA tracking
                $('body').trigger('shoppablemedia:update');
            }
        })
        .catch(() => {
            // Clear widget content in case of error in the response
            shoppableMediaContainer.innerHTML = '';
        })
        .finally(() => {
            $spinner.stop();
        });
}

/**
 * Initializes the shoppable media module.
 * @returns {void}
 */
function initializeShoppableMediaModule() {
    if (!shoppableMediaContainer) return;
    const { shoppablemediaUrl, shoppablemediaProductId } = shoppableMediaContainer.dataset;
    updateShoppableMediaModule(shoppablemediaUrl, shoppablemediaProductId);

    // Update widget when swatch is changed
    const $body = $('body');
    $body.on('swatchChangeEvent', (event, el) => {
        if (!el) return;
        const isColorSwatch = el.closest('.js-color-attribute');
        if (!isColorSwatch) return;

        const { shoppablemediaUrl, productId, masterId, variantCacheKey, attrValue } = isColorSwatch.dataset;
        const variantKey = variantCacheKey || attrValue;
        const hasShoppableMedia = masterId && variantKey
            ? window.productInfo?.[masterId]?.variants?.[variantKey]?.hasShoppableMedia
            : undefined;

        if (shoppableMediaContainer) {
            shoppableMediaContainer.dataset.hasShoppableMedia = hasShoppableMedia;
        }

        updateShoppableMediaModule(shoppablemediaUrl, productId);
    });
}

initializeShoppableMediaModule();
